/* Building Blox — custom section behaviour. Currently: the stack builder. */
(function () {
  'use strict';
  if (window.__bbSections) return;
  window.__bbSections = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(p) { return ROOT.replace(/\/$/, '') + p; }

  /* Format cents with the shop's own money format, e.g. "LE {{amount}}". */
  function money(cents, fmt) {
    var value = (cents / 100);
    function withDelims(n, dec, thousand, decimalSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
      return parts.join(decimalSep);
    }
    if (!fmt) return withDelims(value, 2, ',', '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function recalc(root) {
    var fmt = root.getAttribute('data-money-format') || '';
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-bb-sb-item]'));
    var chosen = boxes.filter(function (b) { return b.checked; });
    var total = 0, was = 0;
    chosen.forEach(function (b) {
      total += Number(b.getAttribute('data-price') || 0);
      was += Number(b.getAttribute('data-compare') || b.getAttribute('data-price') || 0);
    });
    boxes.forEach(function (b) {
      var card = b.closest('.bb-sb__card');
      if (card) card.classList.toggle('is-on', b.checked);
    });
    var n = chosen.length;
    var label = root.querySelector('[data-bb-sb-count]');
    if (label) {
      var word = (label.getAttribute('data-word') || label.textContent.replace(/^\d+\s*/, '')).trim();
      label.setAttribute('data-word', word);
      label.textContent = n + ' ' + word;
    }
    var totalEl = root.querySelector('[data-bb-sb-total]');
    if (totalEl) totalEl.textContent = money(total, fmt);
    var wasEl = root.querySelector('[data-bb-sb-was]');
    if (wasEl) {
      if (was > total) { wasEl.textContent = money(was, fmt); wasEl.hidden = false; }
      else wasEl.hidden = true;
    }
    var saveEl = root.querySelector('[data-bb-sb-save]');
    if (saveEl) {
      if (was > total) { saveEl.textContent = 'Save ' + money(was - total, fmt); saveEl.hidden = false; }
      else saveEl.hidden = true;
    }
    var cta = root.querySelector('[data-bb-sb-add]');
    if (cta) cta.disabled = n === 0;
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-bb-sb-item]');
    if (!box) return;
    var root = box.closest('[data-bb-sb]');
    if (root) recalc(root);
  });

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-bb-sb-add]');
    if (!cta) return;
    e.preventDefault();
    var root = cta.closest('[data-bb-sb]');
    if (!root) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bb-sb-item]'))
      .filter(function (b) { return b.checked; })
      .map(function (b) { return { id: Number(b.value), quantity: 1 }; });
    if (!items.length) return;
    cta.classList.add('is-loading');
    fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Error'); return d; }); })
      .then(function () {
        cta.classList.remove('is-loading');
        cta.classList.add('is-done');
        setTimeout(function () { cta.classList.remove('is-done'); }, 1800);
        return fetch(url('/cart.js')).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        try {
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: state, source: 'bb-stack-builder' });
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state }, bubbles: true }));
        } catch (err) { /* ignore */ }
        var drawer = document.querySelector('#MinimogCartDrawer');
        if (drawer && drawer.classList) drawer.classList.add('is-open');
      })
      .catch(function (err) {
        cta.classList.remove('is-loading');
        try {
          if (window.MinimogTheme && window.MinimogTheme.Notification) {
            window.MinimogTheme.Notification.show({ method: 'open', message: err.message, type: 'warning' });
          }
        } catch (e2) { /* ignore */ }
      });
  });

  function initAll() {
    document.querySelectorAll('[data-bb-sb]').forEach(recalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
